import {
	type DismissOnboardingWelcomeMutation,
	type RegisterOnboardingUploadMutation,
	type SnoozeOnboardingWelcomeMutation,
	type StartOrResumeOnboardingJourneyMutation
} from "~/gql/mutations/onboardingJourney.generated";
import { type GetGoLiveChecklistQuery } from "~/gql/queries/goLiveChecklist.generated";
import {
	type GetMigrationImportQuestionsQuery,
	type GetMigrationPreparedRowsQuery,
	type GetMigrationReviewQuery,
	type GetOnboardingJourneyFilesQuery,
	type GetOnboardingWelcomeQuery
} from "~/gql/queries/onboardingJourney.generated";
import { type GetMyOnboardingPlanQuery } from "~/gql/queries/onboardingPlan.generated";

const onboardingJourneyEndpoints = {
	DismissOnboardingWelcome: {
		invalidatesTags: ["OnboardingJourney"] as AddTagTypes,
		transformResponse: (res: DismissOnboardingWelcomeMutation) => res
	},
	GetGoLiveChecklist: {
		providesTags: ["Customer", "Items", "Price", "Orders", "Users"] as AddTagTypes,
		transformResponse: (res: GetGoLiveChecklistQuery) => res
	},
	GetMigrationImportQuestions: {
		providesTags: ["OnboardingJourney"] as AddTagTypes,
		transformResponse: (res: GetMigrationImportQuestionsQuery) => res
	},
	GetMigrationPreparedRows: {
		providesTags: ["OnboardingJourney"] as AddTagTypes,
		transformResponse: (res: GetMigrationPreparedRowsQuery) => res
	},
	GetMigrationReview: {
		providesTags: ["OnboardingJourney"] as AddTagTypes,
		transformResponse: (res: GetMigrationReviewQuery) => res
	},
	GetMyOnboardingPlan: {
		providesTags: ["Learning", "OnboardingJourney"] as AddTagTypes,
		transformResponse: (res: GetMyOnboardingPlanQuery) => res
	},
	GetOnboardingJourneyFiles: {
		providesTags: ["OnboardingJourney"] as AddTagTypes,
		transformResponse: (res: GetOnboardingJourneyFilesQuery) => res
	},
	GetOnboardingWelcome: {
		providesTags: ["OnboardingJourney"] as AddTagTypes,
		transformResponse: (res: GetOnboardingWelcomeQuery) => res
	},
	RegisterOnboardingUpload: {
		invalidatesTags: ["OnboardingJourney"] as AddTagTypes,
		transformResponse: (res: RegisterOnboardingUploadMutation) => res
	},
	SnoozeOnboardingWelcome: {
		invalidatesTags: ["OnboardingJourney"] as AddTagTypes,
		transformResponse: (res: SnoozeOnboardingWelcomeMutation) => res
	},
	StartOrResumeOnboardingJourney: {
		invalidatesTags: ["OnboardingJourney"] as AddTagTypes,
		transformResponse: (res: StartOrResumeOnboardingJourneyMutation) => res
	}
};

export default onboardingJourneyEndpoints;
